import React, { useCallback, useEffect, useState } from "react";

import { PDFViewer } from "@react-pdf/renderer";
import MyDocument from "./MyDocument";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { dataAction } from "../../../redux/reducers/data";
import { REACT_APP_SERVER_URL } from "../../../config";

const PDF = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.value);
  const [data, SetData] = useState();

  const sendRequest = useCallback(async () => {
    const response = await axios
      .get(`${REACT_APP_SERVER_URL}/user/profile`, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => console.log(err));
    const data = await response.data;
    // console.log(data);

    return data;
  }, [token]);
  useEffect(() => {
    sendRequest()
      .then((data) => {
        SetData(data);
        dispatch(dataAction.AddData(data));
      })
      .catch((err) => console.log(err));
  }, [dispatch, sendRequest]);

  return (
    <PDFViewer style={{ width: '100%', height: '100vh' }}>
      <MyDocument data={data} />
      {/* <Resume data={data} /> */}
    </PDFViewer>
  );
};

export default PDF;
